module.exports = __webpack_public_path__ + "SP_SPT1-Puppy-c8f0f2eb866972ec8133c5cbe8557267.png";